// src/styles/theme.ts
export const theme = {
  colors: {
    background: "#0A0E1A", // Azul escuro mais suave
    backgroundGradient:
      "radial-gradient(ellipse at top, #1a2332 0%, #0A0E1A 50%, #050A14 100%)",
    backgroundSecondary: "#0F1420",
    primary: "#1E90FF", // Azul dodger mais acessível (WCAG AA)
    primaryLight: "#4DA8FF",
    primaryDark: "#0066CC",
    secondary: "#00D4FF", // Azul cyan vibrante
    secondaryLight: "#33DDFF",
    text: "#F8FAFC", // Branco mais suave
    textSecondary: "#94A3B8", // Cinza azulado melhor contraste
    textTertiary: "#64748B",
    accent: "#00D4FF",
    accentGradient: "linear-gradient(135deg, #1E90FF 0%, #00D4FF 100%)",
    darkBlue: "#0F1729",
    card: "#111827", // Card com melhor contraste
    cardHover: "#1F2937",
    cardBorder: "rgba(30, 144, 255, 0.15)",
    buttonGradient: "linear-gradient(135deg, #1E90FF 0%, #00D4FF 100%)",
    buttonHover: "linear-gradient(135deg, #4DA8FF 0%, #33DDFF 100%)",
    progressBar:
      "linear-gradient(90deg, #0066CC 0%, #1E90FF 50%, #00D4FF 100%)",
    shadow: "rgba(30, 144, 255, 0.4)",
    shadowStrong: "rgba(30, 144, 255, 0.6)",
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    overlay: "rgba(10, 14, 26, 0.85)",
  },
  fonts: {
    main: "'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading:
      "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'Fira Code', 'Consolas', 'Monaco', monospace",
  },
  fontSizes: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    base: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "1.875rem", // 30px
    "4xl": "2.25rem", // 36px
    "5xl": "3rem", // 48px
    "6xl": "3.75rem", // 60px
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  lineHeights: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
    loose: 2,
  },
  spacing: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "1rem", // 16px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
    "2xl": "2.5rem", // 40px
    "3xl": "3rem", // 48px
    "4xl": "4rem", // 64px
    "5xl": "5rem", // 80px
  },
  sizes: {
    maxWidth: "1280px",
    maxWidthNarrow: "960px",
    maxWidthWide: "1440px",
  },
  transitions: {
    fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
    default: "300ms cubic-bezier(0.4, 0, 0.2, 1)",
    slow: "500ms cubic-bezier(0.4, 0, 0.2, 1)",
    bounce: "500ms cubic-bezier(0.68, -0.55, 0.265, 1.55)",
  },
  borderRadius: {
    xs: "2px",
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    "2xl": "24px",
    full: "9999px",
  },
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    md: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    lg: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    xl: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    neon: "0 0 20px rgba(30, 144, 255, 0.5), 0 0 40px rgba(30, 144, 255, 0.3)",
    neonStrong:
      "0 0 30px rgba(30, 144, 255, 0.7), 0 0 60px rgba(30, 144, 255, 0.5)",
    card: "0 8px 24px rgba(30, 144, 255, 0.12), 0 2px 8px rgba(0, 0, 0, 0.3)",
    cardHover:
      "0 12px 32px rgba(30, 144, 255, 0.2), 0 4px 12px rgba(0, 0, 0, 0.4)",
    inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
  },
  zIndex: {
    base: 1,
    dropdown: 10,
    sticky: 20,
    fixed: 30,
    menu: 40,
    overlay: 50,
    modal: 60,
    tooltip: 70,
  },
  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },
};
